import store from "../store";
import { clearMenu } from "../store/slices/menuSlice";
import { clearAuthInfo } from "../store/slices/authSlice";
import { removeSkuCreatDraft } from "../store/browser-store";

export const logout = (): void => {
    removeSkuCreatDraft();
    store.dispatch(clearMenu());
    store.dispatch(clearAuthInfo());
};
